// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  width: 100%;
  padding: 0 20px; 
}`, "",{"version":3,"sources":["webpack://./src/app/messages-tab/messages-tab.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".search-bar {\n  width: 100%;\n  padding: 0 20px; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
